module.exports = __webpack_public_path__ + "img/apache.3eb3df10.svg";